
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "075d4ed6-c000-487b-a55f-3b92bdf4c993"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/app/base/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
